<template>
	<VideoRowShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		:id-key="idKey"
		@select="$emit('select')"
	/>
</template>

<script>
	import VideoRowShell from '../shared/VideoRowShell.vue';
	import { mediaBlockEmits, mediaBlockProps } from '../shared/mediaBlockProps.js';

	export default {
		name: 'GBlockVideoRow',
		components: { VideoRowShell },
		props: mediaBlockProps,
		emits: mediaBlockEmits,
	};
</script>
